module.exports = __webpack_public_path__ + "assets/img/33_841_big.6acfc7d2.jpg";